import React from 'react';
import wb0 from '../img/Detail/nau_detail.jpg';
import './Detail.css';
const NauDetail = () => {
  return (
    <div className="image-detail-container">
      <img src={wb0} alt="Kuş" />
    </div>
    
  );
};

export default NauDetail;